export default __webpack_public_path__ + "static/media/referral.c5f7f9e4.png";